import React from "react";
import { PageHeading } from "components/pageHeading";
import { SubHeading } from "components/subHeading";
import "./PricingOption.scss"
import { PackageInfo } from "components/packageInfo";
import { AmsLanding } from 'components/amsLanding';
import { navigate } from "@reach/router";
import { getAmounts } from "core/services/amountService";
import moment from "moment";
import { Button } from "components/button";
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { Popup } from "components/Popup"
import { AffirmTextLandingPage } from "components/affirmTextLandingPage"

import { AmsAccordion } from "components/accordion";
import { faqsData } from "components/amsLanding/faqs";
import Spinner from '../spinner/spinner';
import { FormControl } from 'react-reactive-form';
import { RadioButton } from "components/radioButton";
import { callNowSMSService } from "core/services/callNowSMSService"
import { StickyContainer, Sticky } from 'react-sticky';
import { movingFaqsData } from "./movingFaqs"
declare var window: any;
var currentAmounts: any = []
var depositAmt: any = ""
let renderCount = 0;
export interface PricingOptionProps {
    onClick?(): void;
    formControl?: FormControl;
}

export interface PricingOptionState {
    open?: boolean;
    amounts: any[];
    totalAmt: any;
    loading: boolean;
    borderColor: any;
    textColor: any;
    selectedValue?: any;
    Customer: any;
    spanColor: any;
    deposit: any;
}

class PricingOption extends React.Component<PricingOptionProps, PricingOptionState> {
    private _isMounted: boolean = false;
    constructor(props: PricingOptionProps) {
        super(props);
        this.state = {
            open: false,
            amounts: [],
            totalAmt: null,
            loading: true,
            // borderColor: '1px solid #fff',
            // textColor: "#4f4f4f",
            Customer: [],
            selectedValue: 0,
            borderColor: '1px solid #219653',
            textColor: "#219653",
            spanColor: "#1A1A1A",
            deposit: ""

        };
    }

    handleOpen = (amt: any, month: any, index: number) => {
        // alert(amt+"aaaaaaa"+month)
        localStorage.setItem("selectedamt", amt)
        localStorage.setItem("selectedmonth", month)
        localStorage.setItem("isAffirm", "1");
        //navigate("/amsLanding");
        //navigate("/move?question=paperwork");
        //this.onDirectPayment(amt);
        // if (this.props.onClick) {
        //     this.props.onClick();
        // }

        this.setState({ selectedValue: index })
    };

    onDirectPayment(value: any) {
        //  debugger;
        localStorage.setItem("isAffirm", "0");
        // if (this.props.onClick) {
        // this.props.onClick();
        this.setState({
            borderColor: '1px solid #219653',
        })
        this.setState({
            textColor: "#219653"
        })
        // }
        this.setState({ selectedValue: 0 })
    }

    async fetchData() {
        // debugger;
        var cid = (localStorage.getItem("CID") || "");
        localStorage.setItem("isAffirm", "0");
        //var cid="6980914";
        let response = await getAmounts(cid);

        localStorage.setItem("amounts", JSON.stringify(response.data.getEstFlowTotalAmountsAndDetails))
        console.log(response.data.getEstFlowTotalAmountsAndDetails)
        currentAmounts = JSON.parse(localStorage.getItem("amounts") || '{}')
        depositAmt = currentAmounts[4].amount
        console.log(currentAmounts)
        console.log(currentAmounts[0].amount)
        console.log(depositAmt)
        console.log(depositAmt.amount)

        this.setState({ amounts: currentAmounts, totalAmt: currentAmounts.find((item: any) => item.type === "Total"), loading: false, deposit: depositAmt, Customer: localStorage.getItem("customerDetails") });
        if (this.props.formControl) {
            // debugger;
            this.props.formControl.setValue(true);
        }
        if (!this.props.formControl) {
            //  debugger;
        }
    }
/* componentWillMount(){
    window.affirm.ui.refresh();
} */
    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
        //  this.setState({loading:false});
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    openPopup = () => {
        this.setState({ open: true });
    }
    bookNow() {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }

    async sendSMS() {


        var customer = JSON.parse(this.state.Customer)
        /*   var customerID = customer.customerID
          var customerName = customer.customerName
          var estimatorPh = customer.estimatorPhone
          var customerPh = customer.customerPh
          console.log(customerID)
          console.log(customerName)
          console.log(estimatorPh)
          console.log(customerPh) */
        let response = await callNowSMSService(customer.customerID, customer.customerName, customer.estimatorPhone, customer.customerPh);
        console.log(response)
    }
    render() {
        var object = JSON.parse(localStorage.getItem("movewith") || '{}');
        var address = object.address + ", #" + object.Unit
        var weekday = moment(object.MoveDate).format("d")
        var isSuper = parseInt(weekday) <= 3 ? 1 : 0;
        //  var amounts = JSON.parse(localStorage.getItem("amounts") || '{}')
        // console.log(this.state.amounts)
        // debugger;
        var deposit = 100
        window.affirm.ui.refresh();

        const { selectedValue } = this.state;
        return (
            this.state.loading ? <Spinner /> :
                <div className="option-container">
                    <div className="container relative">
                        <div
                            className="gap tall"
                            style={{ background: "#f3f3f3" }}
                        >
                            <div className="gap short" />
                            <div className="price-title">
                                {/* {
                        isSuper ? <h1>choose your flexible super deal pricing</h1>
                            : <h1>choose your flexible  pricing</h1>
                    } */}
                                <h1>Choose Your Pricing</h1>
                            </div>
                            <div className={selectedValue === 0 ? 'sticky pricing-green-btn ' : ' pricing-green-btn'} onClick={() => this.onDirectPayment(this.state.totalAmt && this.state.totalAmt.amount)} style={{ border: selectedValue === 0 ? this.state.borderColor : "1px solid #ffffff" }}>
                                <RadioButton value={0} selectedValue={selectedValue} />
                                <p style={{ color: selectedValue === 0 ? this.state.textColor : "#4f4f4f" }}>${this.state.totalAmt && this.state.totalAmt.amount}</p><div className="amount-today"><p style={{ color: selectedValue === 0 ? this.state.spanColor : "#4f4f4f", }}>${this.state.deposit} today,</p><p>the rest on Move Day</p></div>
                            </div>
                            <div className="seperator">
                                <div className="seperator-line"></div>
                                <div><p>OR</p></div>
                                <div className="seperator-line"></div>
                            </div>
                            <PageHeading heading={"Move Now, Pay Later"} />
                            <div className="subheading-popup">
                                <SubHeading subheading={"Starting As Low As"} />
                                <div className="icon-info affirm-site-modal"></div>
{/*                                 <SimpleLineIcon name="info" onClick={() => this.openPopup()} />
                                <Popup open={this.state.open} onClose={() => this.setState({ open: false })}
                                // title={"Basic Materials"}
                                // content={`Materials included: 1 roll of tape, 1 mattress bag and 1 tv carton.`}
                                >
                                    <AffirmTextLandingPage />
                                </Popup> */}
                            </div>
                            {
                                this.state.amounts.map((item, index) => {
                                    if (item.type !== "Total" && item.type !== "Deposit")
                                        return (
                                            <div key={item.amount} className={selectedValue === index + 1 ? 'sticky pricing-blue-btn ' : ' pricing-blue-btn'} onClick={() => this.handleOpen(item.amount, item.month, index + 1)} style={{ border: selectedValue === index + 1 ? '1px solid #4E9CE6 ' : ' 1px solid #ffffff' }}>
                                                <RadioButton value={index + 1} selectedValue={selectedValue} />
                                                <p style={{ color: selectedValue === index + 1 ? '#4E9CE6 ' : '#4f4f4f' }}><span className="amount-span">${item.amount}</span> /mo for {item.month} Months</p>
                                            </div>
                                        )
                                })
                            }




                            <div className="sticky sticky-buttons">
                                <div className="booknow-btn">
                                    <Button
                                        text={"Book Now"}
                                        onClick={() => this.bookNow()}
                                    />
                                </div>
                                <div className="callme-btn">
                                    <Button
                                        text={"call me to discuss"}
                                        backgroundColor={"white"}
                                        color={"#219653"}
                                        // borderColor={"1px solid #219653"}
                                        onClick={() => this.sendSMS()}
                                    />
                                </div>
                            </div>


                            <div className="gap short" />
                            {/* <h2>scrolling container</h2> */}

                            {/* FAQs */}
                            <div className='faqs-container'>
                                <h2 className='faqs-heading'>FAQs</h2>
                                <AmsAccordion data={faqsData} expandByDefault={true}></AmsAccordion>
                            </div>

                            {/* Moving FAQs */}
                            <div className='faqs-container'>
                                <h2 className='faqs-heading'>Moving FAQs</h2>
                                <AmsAccordion data={movingFaqsData} expandByDefault={true}></AmsAccordion>
                            </div>

                        </div>
                    </div>

                </div>
        );
    }
}

export default PricingOption;
